import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Tabs as GeneralTabs } from '@fullscreendigital/carrefour-dex-fe'
import { TabsProps } from './TabsDefinitions'
import { useMediaQuery } from '@mui/material'

const Tabs = (props: TabsProps) => {
  const { tabs, tabsContainerStyle } = props

  let [searchParams, setSearchParams] = useSearchParams()

  const [selectedValue, setSelectedValue] = useState<number>(0)

  useEffect(() => {
    if (searchParams.get('tab') === null) {
      setSelectedValue(0)
      searchParams.set('tab', `0`)
      setSearchParams(searchParams, { replace: true })
    } else {
      setSelectedValue(parseInt(searchParams.get('tab')))
    }
  }, [searchParams.get('tab')])

  const onChange = (_, newValue: number) => {
    searchParams.set('tab', `${newValue}`)
    setSearchParams(searchParams, { replace: true }) // [~] otherwise, onBack (very annoyingly) cycles through tabs if the user flicked through them several times
  }

  const isXs = useMediaQuery('(max-width:624px)')
  // TODO: Move styles external
  return (
    <GeneralTabs
      onChange={onChange}
      tabs={tabs}
      value={selectedValue}
      tabsContainerStyle={
        tabsContainerStyle
          ? tabsContainerStyle
          : {
              borderBottom: 1,
              borderColor: '#E5E5E5',
              margin: isXs ? '18px 12px 0' : '36px 0 0'
            }
      }
      tabContentBoxStyle={{ padding: '0' }}
      tabsStyle={{ fontSize: isXs ? '1rem !important' : '1rem', textTransform: 'none' }}
    />
  )
}

export default Tabs
